export var SIZES_MAP = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96,
};
export var DEFAULT_SIZE = SIZES_MAP.small;
//# sourceMappingURL=constants.js.map